import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, MapPin } from 'lucide-react';
export function HeroSection() {
  const [isFocused, setIsFocused] = useState(false);
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className="pt-12 pb-6 px-6 space-y-6" data-id="element-44">
      <div className="flex justify-between items-start" data-id="element-45">
        <div className="space-y-1" data-id="element-46">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2,
          duration: 1
        }} className="text-titanium-400 text-xs uppercase tracking-[0.2em] font-medium" data-id="element-47">
            {new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'long',
            day: 'numeric'
          })}
          </motion.p>
          <h1 className="text-3xl md:text-4xl text-desert-sand font-light" data-id="element-48">
            Good Evening,
            <br data-id="element-49" />
            <span className="font-medium text-white" data-id="element-50">Alexander</span>
          </h1>
        </div>
        <div className="flex items-center gap-1.5 glass-card px-3 py-1.5 rounded-full" data-id="element-51">
          <MapPin className="w-3.5 h-3.5 text-desert-dusk" data-id="element-52" />
          <span className="text-xs text-titanium-300 font-medium tracking-wide" data-id="element-53">
            Geneva
          </span>
        </div>
      </div>

      <motion.div className={`glass-card rounded-2xl flex items-center px-4 py-3 transition-all duration-500 ${isFocused ? 'ring-1 ring-desert-dusk/30 bg-white/[0.05]' : ''}`} layout data-id="element-54">
        <Search className={`w-5 h-5 transition-colors duration-300 ${isFocused ? 'text-desert-dusk' : 'text-titanium-400'}`} data-id="element-55" />
        <input type="text" placeholder="How can we assist you today?" className="bg-transparent border-none outline-none text-sm text-white placeholder:text-titanium-400 ml-3 w-full font-light" onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} data-id="element-56" />
      </motion.div>
    </motion.section>;
}